var _path, _path2, _path3, _path4, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTermsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 7V17C21 20 19.5 22 16 22H8C4.5 22 3 20 3 17V7C3 4 4.5 2 8 2H16C19.5 2 21 4 21 7Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 4.5V6.5C14.5 7.6 15.4 8.5 16.5 8.5H18.5",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 13H12",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 17H16",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19786_7573)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 13.5L15.5 14.5V15.5L16 19L18 21.5H19.5L21.5 21L23 17.5L22.5 14.5L22 13.5L20.5 13L16.5 13.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.34 13.347L21.34 12.331C21.235 12.278 21.118 12.25 21 12.25H17C16.882 12.25 16.766 12.278 16.66 12.331L14.66 13.347C14.408 13.475 14.25 13.734 14.25 14.016V16.633C14.25 19.291 15.91 21.703 18.383 22.637C18.581 22.712 18.79 22.75 19 22.75C19.21 22.75 19.419 22.712 19.618 22.636C22.09 21.703 23.75 19.291 23.75 16.633V14.016C23.75 13.734 23.592 13.475 23.34 13.347ZM22.25 16.633C22.25 18.67 20.979 20.519 19.086 21.235C19.031 21.255 18.972 21.256 18.911 21.235C17.02 20.52 15.75 18.672 15.75 16.634V14.477L17.18 13.751H20.821L22.251 14.477V16.634L22.25 16.633ZM21 15.429C21.309 15.705 21.335 16.179 21.06 16.489L19.26 18.505C19.117 18.664 18.914 18.755 18.7 18.755C18.486 18.755 18.283 18.664 18.14 18.505L16.94 17.161C16.665 16.851 16.691 16.378 17 16.101C17.31 15.824 17.782 15.853 18.06 16.161L18.701 16.879L19.941 15.489C20.217 15.182 20.69 15.153 21 15.429Z",
    fill: "url(#paint0_linear_19786_7573)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_19786_7573",
    x1: 14.9317,
    y1: 9.71875,
    x2: 23.9926,
    y2: 10.5349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7B9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.586388,
    stopColor: "#FC8E83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7F7C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19786_7573"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.25,
    y: 12.25,
    width: 9.5,
    height: 10.5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTermsIcon);
export default __webpack_public_path__ + "static/media/termsIcon.2da0b65e53f0f09ebebd16868eb7994f.svg";
export { ForwardRef as ReactComponent };